import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import locale from "csi/locale";
import session from "csi/session";
import state from "csi/state";
import Nodes from "csi/store/Nodes";
import Path from "csi/table/matrix/Path";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import { C8Node } from "src/c8-platform/type/node";

const CareInstructionsandIconsMatrix = declare(Path, {

	productSalesRegion: null,
	productSalesRegionSpec: null,
	/**
	 * add any dependency paths necessary to process matrix
	 * @param {Heading}
	 * @param {String[]}
	 */
	addDependencyPaths: function(h: Heading, paths: string[]) {
		paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions");
		paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec");
		paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries");
		paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries/Child:Languages");
		this.inherited(arguments);
	},

	addDeferred(ctx, h: Heading, dfds): void {
		// summary: add any deferreds for languages
		const languageStore = new Nodes({
			sortQuery: new Query().SortByAttr("SortOrder"),
			typeNode: "Language",
			cachingStore: ctx.cache,
		});

		dfds.push(languageStore.query());

		var activeProductSalesRegionURLs = ctx.view.activeProductSalesRegions;
		if (activeProductSalesRegionURLs) {
			const qry = new Query();
			const qOr = qry.Or();
			const productSalesRegionNodes = [];
			const productSalesRegionSpecNodes = [];
			activeProductSalesRegionURLs.forEach((salesRegionURL) =>{
				const salesRegionNode = ctx.cache.getNode(salesRegionURL);
				qOr.RefAttr("CountryProductSalesRegionSpecs",  xml.OP_EQUALS, salesRegionNode.ProductSalesRegionSpec);
				productSalesRegionNodes.push(salesRegionNode);
				productSalesRegionSpecNodes.push(ctx.cache.getNode(salesRegionNode.ProductSalesRegionSpec));
				dfds.push(ctx.cache.getNodeDeferred(salesRegionNode.ProductSalesRegionSpec));
			});

			// get the countries of the ProductSalesRegionSpec of the selected ProductSalesRegion
			const countriesStore = new Nodes({
				typeNode: "Country",
				filterQuery: qry,
				cachingStore: ctx.cache,
			});

			dfds.push(countriesStore.query());

			this.productSalesRegion = productSalesRegionNodes;
			this.productSalesRegionSpec = productSalesRegionSpecNodes;
		} else {
			this.productSalesRegion = null;
			this.productSalesRegionSpec = null;
		}
	},
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] | undefined {
		if (!this.productSalesRegionSpec){
			return null;
		}

		return  this.productSalesRegionSpec;
	},

	_getColumnSpecHeaderParams: function(ctx: Context, h: Heading, index: Number): Record<string, any> {
		const hparams = this.inherited<Record<string, any>>(arguments);
		if (h) {
			hparams.innerText = locale.type("ProductSalesRegion") +" - " + hparams.innerText;
		}
		return hparams;
	},

	_getRowNodes: function(/*Context*/ctx, /*QueryResult*/qr, /*Spec*/c, /*Node*/ node) {
		if (state.get("print") && !state.get("printAdHoc")) {
			const url = session.getLocationValue("ProductSalesRegion");

			if (xml.isValidURL(url)) {
				this.productSalesRegionSpec = ctx.cache.getNode(ctx.cache.getNode(url).ProductSalesRegionSpec);
			}
		}

		let languagesInSalesRegion = [];
		//Checking for sellingcountries for now since selling countries is not valid if Productsalesregion is null,
		// or when the table is loaded
		if (c.columnUrl){
			const salesRegionSpecNode = ctx.cache.getNode(c.columnUrl);
			const sellingCountries = salesRegionSpecNode.SellingCountries;
			sellingCountries.forEach((countryURL) => {
				var country = ctx.cache.getNode(countryURL);
				const languagesInCountry = ctx.cache.getNodes(country.Languages);
				languagesInCountry.forEach((languageInCountry) => {
					if (languagesInSalesRegion.length == 0 ) {
						languagesInSalesRegion = languagesInSalesRegion.concat(languageInCountry);
					}
					else {
						let languageNamesInSalesRegion = [];
						languagesInSalesRegion.forEach((languageInSalesRegion) =>{
							languageNamesInSalesRegion = languageNamesInSalesRegion.concat(languageInSalesRegion.$Name);
						});
						if (!languageNamesInSalesRegion.includes(languageInCountry.$Name)) {
							languagesInSalesRegion = languagesInSalesRegion.concat(languageInCountry);
						}
					}
				});
			});
		}
		return languagesInSalesRegion;
	},
});
 export = CareInstructionsandIconsMatrix;